import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  inject,
  SimpleChanges,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { Popover, PopoverModule } from 'primeng/popover';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { Subscription } from 'rxjs';

import { PaginatedAlbumTemplateRecursiveList } from '@offconon/core-api';

import { fetchDriveAlbumItems } from '../../../store/media-gallery.actions';
import { selectDriveAlbumItemsWithSelected } from '../../../store/media-gallery.selectors';
import { MediaFolderContentAlbumCardComponent } from '../media-folder-content-card/media-folder-content-album-card.component';
import { MediaFolderContentCardComponent } from '../media-folder-content-card/media-folder-content-card.component';
import { ListMenuItemComponent } from './list-menu-item.component';

@Component({
  selector: 'offconon-media-folder-content',
  imports: [
    CommonModule,
    TranslateModule,
    PaginatorModule,
    DragDropModule,
    MatIcon,
    TooltipModule,
    ButtonModule,
    MenuModule,
    MediaFolderContentCardComponent,
    TableModule,
    SelectButtonModule,
    PopoverModule,
    ListMenuItemComponent,
    ScrollPanelModule,
    ProgressSpinnerModule,
    MediaFolderContentAlbumCardComponent,
  ],
  templateUrl: './media-folder-content.component.html',
  styles: ``,
})
export class MediaFolderContentComponent implements OnChanges, OnDestroy, OnInit {
  @Input() multiple = false;
  @Input() saveWithCrop = false;
  @Input() allItemSelect = false;
  @Input() resetSelection = false;
  @Input() newFiles = {};
  @Input() canSelect = false;
  @Input() folderList: PaginatedAlbumTemplateRecursiveList | undefined;
  @Input() user_id: number = 0;
  @Input() view: string = 'icon';
  @Input() selectedChildren: any[] = [];
  @Input() currentFolder: any;
  @Input() selectedChildrenParents: any[] = [];
  @Input() business_id: any = null;
  @Input() album_id: number = 0;
  @Input() showType: 'all' | 'image' | 'video' | 'audio' | 'document' | 'zip' | 'other' = 'all';
  @Output() selectedItemEmit = new EventEmitter<any>();
  @Output() selectedItemDeleteEmit = new EventEmitter<any>();
  @Output() selectedFolderIdEmit = new EventEmitter<any>();
  @Output() selectedFolderEmit = new EventEmitter<any>();
  @Output() EditImageEmit = new EventEmitter<any>();
  @Output() ReloadFoldersEmit = new EventEmitter<any>();
  @Output() RefreshFoldersEmit = new EventEmitter<any>();

  @ViewChild('moreItem', { static: false }) loadMoreDiv: ElementRef<HTMLDivElement>;

  @ViewChildren(Popover)
  popovers: QueryList<Popover>;
  isLoadMoreDivScrolledIntoView: boolean;

  items: MenuItem[];
  private store = inject(Store);
  private translateService = inject(TranslateService);
  pageSize = 30;
  tableHeight: string = '400px';
  page: number = 1;
  loading = false;
  tooltipVisible = false;
  private paginatedSubscription: Subscription;
  public datas: any;
  public results: any;
  public currFolder: { id: any } = { id: null };
  public selectedIds: number[] = [];
  public selectedItem: any[] = [];
  public combinedData: any[] = [];
  public sortField: string = 'file_name';
  public sortOrder: number = 1;

  ngOnInit(): void {
    setTimeout(() => {
      this.calculateCalcValue();
    }, 500);

    this.datas = [];
    this.results = [];
    document.addEventListener('scroll', this.scroll, true);
    setTimeout(() => {
      this.paginatedSubscription = this.store
        .select(selectDriveAlbumItemsWithSelected)
        .subscribe((data) => {
          this.datas = data;
          if (data?.results) {
            if (this.page === 1) {
              this.results = data?.results;
            } else {
              data?.results.forEach((result: any) => {
                let index = 0;
                index = this.results.findIndex((item: any) => item.id === result.id);

                if (index === -1) {
                  this.results.push(result);
                } else {
                  this.results[index] = result;
                }
              });
            }
            this.combineData();
          }
        });
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => {
      //this.combineData();
      if (this.currentFolder && this.currentFolder.parent_id) {
        this.currFolder = this.selectedChildrenParents[0];
      }
    }, 1200);
    if (changes['folderList']) {
      this.ReloadFoldersEmit.emit(true);
    }
    if (changes['resetSelection']) {
      if (changes['resetSelection'].currentValue === true) {
        this.resetSelected(true);
      }
    }
    if (changes['allItemSelect']) {
      if (this.results) {
        if (changes['allItemSelect'].currentValue === false) {
          this.selectedItem.forEach((element) => {
            setTimeout(() => {
              this.toggleSelection(element.id);
            }, 20);
            this.selectedItem = [];
            this.selectedIds = [];
          });
        }
        if (changes['allItemSelect'].currentValue === true) {
          this.results.forEach((element: any) => {
            //const index = this.results.findIndex((item: any) => item.id === element.id);
            //this.results[index].selected = false;
            if (!element.selected) {
              setTimeout(() => {
                this.toggleSelection(element.id);
              }, 20);
            }
          });
        }
      }
    }

    if (changes['newFiles'] && changes['newFiles'].currentValue) {
      if (this.showType === 'all') {
        this.store.dispatch(
          fetchDriveAlbumItems({
            page: this.page,
            pageSize: this.pageSize,
            searchJson: {
              album_id: this.album_id,
            },
          }),
        );
      } else {
        this.store.dispatch(
          fetchDriveAlbumItems({
            page: this.page,
            pageSize: this.pageSize,
            searchJson: {
              media_file__content_upload_type: this.showType,
              album_id: this.album_id,
            },
          }),
        );
      }
      setTimeout(() => {
        if (this.view === 'list') {
          this.combineData();
        }
      }, 1500);
    }
    if (
      (changes['showType'] && this.album_id) ||
      (changes['album_id'] && changes['album_id'].currentValue)
    ) {
      this.page = 1;
      this.results = [];
      this.selectedIds = [];
      this.selectedItem = [];
      if (this.showType === 'all') {
        this.store.dispatch(
          fetchDriveAlbumItems({
            page: this.page,
            pageSize: this.pageSize,
            searchJson: {
              album_id: this.album_id,
            },
          }),
        );
      } else {
        this.store.dispatch(
          fetchDriveAlbumItems({
            page: this.page,
            pageSize: this.pageSize,
            searchJson: {
              media_file__content_upload_type: this.showType,
              album_id: this.album_id,
            },
          }),
        );
      }
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('scroll', this.scroll, true);
    if (this.paginatedSubscription) {
      this.paginatedSubscription.unsubscribe();
    }
  }
  calculateCalcValue() {
    const panel = document.querySelector('#drive-scroll-panel .p-scrollpanel') as HTMLElement;

    if (panel) {
      const panelHeight = panel.offsetHeight;

      if (panelHeight > 50) {
        this.tableHeight = `${panelHeight - 40}px`;
      }
    }
  }

  togglePopover(event: any, id: any) {
    const popover = this.popovers
      .toArray()
      .find((popover: Popover) => popover.el.nativeElement.id === String(id));

    if (popover) {
      this.popovers.toArray().forEach((p: Popover) => {
        if (p !== popover) {
          p.hide();
        }
      });

      popover.toggle(event);
    }
  }

  iconNameSet(item: any) {
    let iconName = '';
    switch (true) {
      case item.type === 'media' && item.media_file_type === 'image':
        iconName = 'image';
        break;

      case item.type === 'media' && item.media_file_type === 'video':
        iconName = 'video';
        break;

      case item.type === 'media' && item.media_file_type === 'audio':
        iconName = 'volume-up';
        break;
      case item.type === 'media' && item.media_file_type === 'other':
        iconName = 'file';
        break;
      case item.type === 'media' && item.media_file_type === 'zip':
        iconName = 'file';
        break;
      case item.type === 'media' &&
        item.media_file_type === 'document' &&
        item.extension.includes('doc'):
        iconName = 'file-word';
        break;
      case item.type === 'media' &&
        item.media_file_type === 'document' &&
        item.extension.includes('xls'):
        iconName = 'file-excel';
        break;
      case item.type === 'media' &&
        item.media_file_type === 'document' &&
        item.extension.includes('pdf'):
        iconName = 'file-pdf';
        break;
      case item.type === 'media' && item.media_file_type === 'document':
        iconName = 'file';
        break;
      case item.extension?.includes('application/zip'):
        iconName = 'zip';
        break;

      default:
        iconName = 'folder';
        break;
    }
    return iconName;
  }
  trackByIndex(index: number): any {
    return index;
  }

  combineData() {
    let sortField = this.sortField;
    let sortOrder = this.sortOrder;
    let albumSortField = '';

    if (sortField === 'file_name') {
      albumSortField = 'name';
    } else {
      albumSortField = sortField;
    }

    const placeholder =
      this.currentFolder && this.currentFolder.parent_id ? [{ isPlaceholder: true }] : [];

    this.combinedData = [];

    const albums = this.selectedChildren
      .map((child) => ({ ...child, type: 'album' }))
      .sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));

    const mediaFiles = this.results
      .map((media: any) => ({
        ...media,
        type: 'media',
        file_name: media.file_name || '',
      }))
      .sort((a: any, b: any) =>
        a.file_name.localeCompare(b.file_name, 'en', { sensitivity: 'base' }),
      );

    const sortedAlbums = [...albums].sort((a, b) => {
      const valA = a[albumSortField];
      const valB = b[albumSortField];

      if (sortField === 'file_size') {
        if (valA < valB) return -sortOrder;
        if (valA > valB) return sortOrder;
      } else {
        if (valA.toLowerCase() < valB.toLowerCase()) return -sortOrder;
        if (valA.toLowerCase() > valB.toLowerCase()) return sortOrder;
      }
      return 0;
    });

    const sortedMediaFiles = [...mediaFiles].sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];

      if (sortField === 'file_size') {
        if (valA < valB) return -sortOrder;
        if (valA > valB) return sortOrder;
      } else {
        if (valA.toLowerCase() < valB.toLowerCase()) return -sortOrder;
        if (valA.toLowerCase() > valB.toLowerCase()) return sortOrder;
      }
      return 0;
    });

    this.combinedData = [...placeholder, ...sortedAlbums, ...sortedMediaFiles];
  }

  onSort(event: any) {
    let newSort = 0;
    const sortField = event.field;
    const sortOrder = event.order;
    if (this.sortField !== sortField || this.sortOrder !== sortOrder) {
      this.sortField = event.field;
      this.sortOrder = event.order;
      newSort = 1;
    }
    if (newSort) {
      this.combineData();
    }
  }

  toggleTooltip() {
    this.tooltipVisible = !this.tooltipVisible;
  }
  resetSelected(event: any) {
    if (event) {
      this.selectedItem = [];
      this.selectedIds = [];
      if (this.results && this.results.length > 0) {
        this.results.forEach((element: any) => {
          const isSelected = element.selected;
          if (isSelected) {
            element.selected = false;
          }
        });
      }

      this.resetSelection = false;
      this.selectedItemEmit.emit(this.selectedItem);
    }
  }

  onDragStart(event: DragEvent, media: any) {
    if (media.media_file_type) {
      event.dataTransfer?.setData('mediaId', media.id);
    } else {
      event.dataTransfer?.setData('albumId', media.id);
    }

    event.dataTransfer?.setData('mediaType', media.media_file_type);
  }

  scroll = () => {
    this.checkIfInView();
  };

  movedFolder(event: any) {
    setTimeout(() => {
      const movedId = event;
      this.combinedData = this.combinedData.filter((item) => {
        return item.type !== 'album' || item.id !== movedId;
      });
    }, 500);
  }
  editedFolder(event: any) {
    setTimeout(() => {
      this.RefreshFoldersEmit.emit(true);
    }, 200);
  }
  deletedFolder(event: any) {
    setTimeout(() => {
      this.RefreshFoldersEmit.emit(true);
      const deleteId = event;
      this.combinedData = this.combinedData.filter((item) => {
        return item.type !== 'album' || item.id !== deleteId;
      });
    }, 500);
  }
  deletedId(event: any) {
    setTimeout(() => {
      const deletedId = event;
      this.combinedData = this.combinedData.filter((item) => item.id !== deletedId);
    }, 1000);
  }

  checkIfInView() {
    if (!this.loading) {
      const rect = this.loadMoreDiv?.nativeElement.getBoundingClientRect();
      const isInView = rect?.top >= 0 && rect.bottom <= window.innerHeight;

      this.isLoadMoreDivScrolledIntoView = isInView;
      if (isInView && !this.loading) {
        this.loadMore();
      }
    }
  }
  selectedFolderId(item: any) {
    this.selectedFolderEmit.emit(item);
    this.selectedFolderIdEmit.emit(item.id);
  }
  editImage(url: any) {
    this.EditImageEmit.emit(url);
  }
  loadMore() {
    if (this.results.length > 0) {
      this.loading = true;
      if (this.page > (this.datas?.total_pages || 0)) {
        return;
      }
      this.page++;
      if (this.showType === 'all') {
        this.store.dispatch(
          fetchDriveAlbumItems({
            page: this.page,
            pageSize: this.pageSize,
            searchJson: {
              album_id: this.album_id,
            },
          }),
        );
      } else {
        this.store.dispatch(
          fetchDriveAlbumItems({
            page: this.page,
            pageSize: this.pageSize,
            searchJson: {
              media_file__content_upload_type: this.showType,
              album_id: this.album_id,
            },
          }),
        );
      }
      setTimeout(() => {
        this.loading = false;
        this.combineData();
      }, 500);
    }
  }

  paginationChanged(event: any) {
    this.page = event.page + 1;
    if (this.showType === 'all') {
      this.store.dispatch(
        fetchDriveAlbumItems({
          page: this.page,
          pageSize: this.pageSize,
          searchJson: {
            album_id: this.album_id,
          },
        }),
      );
    } else {
      this.store.dispatch(
        fetchDriveAlbumItems({
          page: this.page,
          pageSize: this.pageSize,
          searchJson: {
            media_file__content_upload_type: this.showType,
            album_id: this.album_id,
          },
        }),
      );
    }
  }

  toggleSelection(id: number): void {
    const index = this.results.findIndex((item: any) => item.id === id);
    let del = false;

    if (index !== -1) {
      const isSelected = this.results[index].selected;
      if (this.multiple) {
        this.results[index].selected = !isSelected;

        if (this.results[index].selected) {
          this.selectedIds.push(id);
          this.selectedItem.push(this.results[index]);
        } else {
          this.selectedIds = this.selectedIds.filter((itemId) => itemId !== id);
          this.selectedItem = this.selectedItem.filter((item: any) => item.id !== id);
          if (this.canSelect) {
            del = true;
            this.selectedItemDeleteEmit.emit(id);
          }
        }
      } else {
        this.selectedItem = [];

        if (isSelected) {
          this.results[index].selected = false;
          this.selectedIds = this.selectedIds.filter((itemId) => itemId !== id);
          if (this.canSelect) {
            del = true;
            this.selectedItemDeleteEmit.emit(id);
          }
        } else {
          this.results[index].selected = true;
          this.selectedIds = [id];
          this.selectedItem = [this.results[index]];
        }

        if (this.selectedIds.length > 0) {
          this.results.forEach((item: any) => {
            if (!this.selectedIds.includes(item.id)) {
              item.selected = false;
            }
          });
        }
      }
    }
    if (!del) {
      this.selectedItemEmit.emit(this.selectedItem);
    }
    this.combineData();
  }
}
